import { useEffect } from "react"
import { useSignal } from "@preact/signals-react"
import { ValidationError } from "yup"

export default function useValidatorSeeker(dataSend, schema) {
    const errors = useSignal({})

    useEffect(() => {
        try {
            schema.validateSync(dataSend, { abortEarly: false })
            errors.value = {}
        } catch (err) {
            if (err instanceof ValidationError) {
                errors.value = err.inner.reduce((acc, error) => ({
                    ...acc,
                    [error.path]: error.message,
                }), {})
            } else {
                throw err
            }
        }
    }, [JSON.stringify(dataSend), JSON.stringify(schema.describe())])

    return { errors: errors.value }
}
